import { render, staticRenderFns } from "./group_attached_products.vue?vue&type=template&id=fde813da&scoped=true&"
import script from "./group_attached_products.vue?vue&type=script&lang=js&"
export * from "./group_attached_products.vue?vue&type=script&lang=js&"
import style0 from "./group_attached_products.vue?vue&type=style&index=0&id=fde813da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde813da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fde813da')) {
      api.createRecord('fde813da', component.options)
    } else {
      api.reload('fde813da', component.options)
    }
    module.hot.accept("./group_attached_products.vue?vue&type=template&id=fde813da&scoped=true&", function () {
      api.rerender('fde813da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/modifiers/groups/tabs/group_attached_products.vue"
export default component.exports